import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import smakonecup from "../Assets/blackobor.png";

function Navbar() {
  const [menuVisible, setMenuVisible] = useState(false);
  const navigate = useNavigate();

  function toggleMenu() {
    setMenuVisible(!menuVisible);
  }

  function handleHomeClick() {
    window.scrollTo({ top: 0, behavior: "smooth" }); // scroll ke atas
    setMenuVisible(false); // tutup menu kalau di mobile
    navigate("/"); // tetap navigasi ke home
  }

  return (
    <div className="w-full bg-white fixed top-0 bottom-15 z-50 shadow-xl">
      {/* MAIN NAVBAR */}
      <div className="flex items-center justify-between w-full h-38 px-4 lg:px-20">
        {/* LOGO + TITLE */}
        <button className="flex items-center flex-shrink-0" onClick={handleHomeClick}>
          <img src={smakonecup} alt="Logo" className="object-contain h-16 w-16" />
          <div className="text-black text-3xl font-extrabold font-plusjakartasans -ml-3">Smakonecup</div>
        </button>

        {/* DESKTOP MENU */}
        <ul className="hidden lg:flex w-full justify-end gap-10 text-lg font-medium text-black font-plusjakartasans">
          <li className="hover-text-soc">
            <button onClick={handleHomeClick}>Home</button>
          </li>
          <li className="hover-text-soc">
            <Link to="https://docs.google.com/document/d/19INiHyk-ZZZKMCcVTf4EHlYTQs_-a_cL2G8CFYG8uGw/edit?usp=sharing" target="_blank">Documentations</Link>
          </li>
          <li className="hover-text-soc">
            <Link to="/scoreboard">Scoreboard</Link>
          </li>
          <li className="hover-text-soc">
            <a href="https://socregis.smakone.org" title="Please use DESKTOP">
              Registration
            </a>
          </li>
        </ul>

        {/* MOBILE MENU BUTTON */}
        <button onClick={toggleMenu} className="lg:hidden flex items-center">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="black" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 
              7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 
              5 20 5H4ZM7 12C7 11.4477 7.44772 11 8 
              11H20C20.5523 11 21 11.4477 21 12C21 
              12.5523 20.5523 13 20 13H8C7.44772 13 
              7 12.5523 7 12ZM13 18C13 17.4477 
              13.4477 17 14 17H20C20.5523 17 21 
              17.4477 21 18C21 18.5523 20.5523 
              19 20 19H14C13.4477 19 13 18.5523 
              13 18Z"
              fill="black"
            />
          </svg>
        </button>
      </div>

      {/* MOBILE MENU */}
      {menuVisible && (
        <div className="block lg:hidden bg-white px-6 py-4 shadow-md font-plusjakartasans">
          <ul className="flex flex-col gap-4 text-base font-medium text-black">
            <li>
              <button onClick={handleHomeClick}>Home</button>
            </li>
            <li onClick={toggleMenu}>
              <Link to="https://docs.google.com/document/d/19INiHyk-ZZZKMCcVTf4EHlYTQs_-a_cL2G8CFYG8uGw/edit?usp=sharing" target="_blank">Documentations</Link>
            </li>
            <li onClick={toggleMenu}>
              <Link to="/scoreboard">Scoreboard</Link>
            </li>
            <li onClick={toggleMenu}>
              <a href="https://socregis.smakone.org" title="Please use DESKTOP">
                Registration
              </a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}

export default Navbar;
